import { useEffect, useState } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { apiAuth, setCsrfToken } from "./api.js";
import { router } from "./router.js";
import { LoginPage } from "./pages/LoginPage.js";
import type { MeResponse } from "@koc/shared";

export function App() {
  const [me, setMe] = useState<MeResponse | null>(null);
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    apiAuth.me()
      .then((m) => { setMe(m); setCsrfToken(m.csrfToken); })
      .catch(() => { setMe(null); })
      .finally(() => setBootstrapped(true));
  }, []);

  if (!bootstrapped) {
    return <div className="flex h-screen items-center justify-center text-stone-500">Loading…</div>;
  }
  if (!me) {
    return <LoginPage onLoggedIn={(m) => { setMe(m); setCsrfToken(m.csrfToken); }} />;
  }
  return <RouterProvider router={router} />;
}
